

(function () {
  'use strict';

  const TMH = window.TMH || {};
  if (!TMH.config) {
    console.warn('[TMH] config non caricato — controlla snippets/tmh-storefront-config.liquid');
    return;
  }

  const CODICE_REGEX = TMH.config.codiceRegex;
  const SESSION_KEY = TMH.config.sessionStorageKey;
  const DEBUG = TMH.config.debugMode;

  function log(...args) {
    if (DEBUG) console.log('[TMH cart]', ...args);
  }

  
  
  
  
  
  
  
  
  
  
  

  let _ambulanti = null;

  function getAllAmbulanti() {
    if (_ambulanti) return _ambulanti;
    const nodo = document.getElementById('tmh-cart-ambulanti');
    if (!nodo) {
      log('Blocco dati ambulanti assente');
      _ambulanti = [];
      return _ambulanti;
    }
    try {
      _ambulanti = JSON.parse(nodo.textContent) || [];
    } catch (e) {
      log('Blocco dati ambulanti illeggibile', e);
      _ambulanti = [];
    }
    return _ambulanti;
  }

  function validaCodice(codice) {
    if (!CODICE_REGEX.test(codice)) {
      return { valid: false, error: 'FORMAT_INVALID' };
    }

    const node = getAllAmbulanti().find((a) => a.codice === codice);

    if (!node) return { valid: false, error: 'CODICE_NOT_FOUND' };
    if (String(node.isAttivo) !== 'true') return { valid: false, error: 'AMBULANTE_NOT_ACTIVE' };
    if (String(node.isFacilitatore) !== 'true') return { valid: false, error: 'NON_FACILITATORE' };
    if (!node.mercati || node.mercati.length === 0) return { valid: false, error: 'AMBULANTE_NO_MERCATI' };

    return {
      valid: true,
      ambulante: {
        codice: node.codice,
        nome: node.nome,
        provincia: node.provincia,
        isFacilitatore: true,
        mercati: node.mercati,
      },
    };
  }

  
  
  

  async function setCartAttributes(attrs) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    });
    return response.json();
  }

  async function getCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  
  
  

  function readMessages(root) {
    const d = root.dataset;
    return {
      FORMAT_INVALID: d.tmhMsgFormatInvalid,
      CODICE_NOT_FOUND: d.tmhMsgCodiceNotFound,
      AMBULANTE_NOT_ACTIVE: d.tmhMsgAmbulanteNotActive,
      NON_FACILITATORE: d.tmhMsgNonFacilitatore,
      AMBULANTE_NO_MERCATI: d.tmhMsgAmbulanteNoMercati,
      NETWORK_ERROR: d.tmhMsgNetworkError,
      ANNULLA_CONFERMA: d.tmhMsgAnnulla,
      VERIFICA_IN_CORSO: d.tmhMsgVerifica,
      ERRORE_GENERICO: d.tmhMsgGenerico,
    };
  }

  
  
  

  const gateSources = new Map();

  function setGateSource(root, fn) {
    gateSources.set(root, fn);
  }

  function applyCheckoutGate() {
    gateSources.forEach((fn, root) => {
      if (!document.contains(root)) gateSources.delete(root);
    });

    let isValid = true;
    gateSources.forEach((fn) => {
      if (!fn()) isValid = false;
    });

    const checkoutBtns = document.querySelectorAll(
      'button[name="checkout"], #checkout, [name="checkout"], .cart__checkout-button, button.cart__checkout',
    );

    checkoutBtns.forEach((btn) => {
      btn.disabled = !isValid;
      if (isValid) {
        btn.removeAttribute('aria-disabled');
        btn.style.opacity = '';
        btn.style.cursor = '';
      } else {
        btn.setAttribute('aria-disabled', 'true');
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
      }
    });

    log('Checkout gate', { sorgenti: gateSources.size, isValid: isValid });
    return isValid;
  }

  class TMHCartModality {
    constructor(root) {
      this.root = root;
      this.msg = readMessages(root);
      this.els = {
        radios: root.querySelectorAll('[data-tmh-modality-input]'),
        radioLabels: root.querySelectorAll('[data-tmh-radio]'),
        expands: root.querySelectorAll('[data-tmh-expand]'),
        codiceInput: root.querySelector('[data-tmh-codice-input]'),
        codiceMsg: root.querySelector('[data-tmh-codice-msg]'),
        confermaCard: root.querySelector('[data-tmh-conferma-card]'),
        cardNome: root.querySelector('[data-tmh-card-nome]'),
        cardCodice: root.querySelector('[data-tmh-card-codice]'),
        cardProvincia: root.querySelector('[data-tmh-card-provincia]'),
        cardBadge: root.querySelector('[data-tmh-card-badge]'),
        cardMercati: root.querySelector('[data-tmh-card-mercati]'),
        btnCambia: root.querySelector('[data-tmh-cambia]'),
        btnConferma: root.querySelector('[data-tmh-conferma]'),
        minicard: root.querySelector('[data-tmh-minicard]'),
        minicardNome: root.querySelector('[data-tmh-minicard-nome]'),
        minicardCodice: root.querySelector('[data-tmh-minicard-codice]'),
        btnModifica: root.querySelector('[data-tmh-modifica]'),
        codiceForm: root.querySelector('[data-tmh-codice-form]'),
      };

      this.state = {
        modalita: null,
        ambulanteCandidato: null,
        ambulanteConfermato: null,
      };

      this.bind();
      this.restoreFromCart();
      this.updateCheckoutGate();
    }

    bind() {
      this.els.radios.forEach((r) => r.addEventListener('change', () => this.onRadioChange(r.value)));

      if (this.els.codiceInput) {
        this.els.codiceInput.addEventListener('input', (e) => this.onCodiceInput(e));
        this.els.codiceInput.addEventListener('blur', () => this.onCodiceBlur());
        this.els.codiceInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.onCodiceBlur();
          }
        });
      }

      if (this.els.btnCambia) this.els.btnCambia.addEventListener('click', () => this.onCambia());
      if (this.els.btnConferma) this.els.btnConferma.addEventListener('click', () => this.onConferma());
      if (this.els.btnModifica) this.els.btnModifica.addEventListener('click', () => this.onModifica());

      
      try {
        const codiceSaved = sessionStorage.getItem(SESSION_KEY);
        if (codiceSaved && this.els.codiceInput && !this.state.ambulanteConfermato) {
          this.els.codiceInput.value = codiceSaved;
          sessionStorage.removeItem(SESSION_KEY);
          
          const radioRitiro = this.root.querySelector('[data-tmh-modality-input][value="ritiro_mercato"]');
          if (radioRitiro) {
            radioRitiro.checked = true;
            this.onRadioChange('ritiro_mercato');
          }
          
          setTimeout(() => this.onCodiceBlur(), 100);
        }
      } catch (e) {
        log('sessionStorage non disponibile');
      }
    }

    onRadioChange(value) {
      this.state.modalita = value;

      
      this.els.radioLabels.forEach((l) => {
        l.classList.toggle('is-selected', l.dataset.tmhRadio === value);
      });
      this.els.expands.forEach((e) => {
        e.classList.toggle('is-open', e.dataset.tmhExpand === value);
      });

      this.updateCheckoutGate();

      
      if (value === 'spedizione_casa' && this.state.ambulanteConfermato) {
        if (confirm(this.msg.ANNULLA_CONFERMA)) {
          this.clearAmbulante();
        } else {
          
          const radioRitiro = this.root.querySelector('[data-tmh-modality-input][value="ritiro_mercato"]');
          if (radioRitiro) {
            radioRitiro.checked = true;
            this.onRadioChange('ritiro_mercato');
          }
        }
      } else if (value === 'spedizione_casa') {
        
        setCartAttributes({ modalita_consegna: 'spedizione_casa' });
      }
    }

    onCodiceInput(e) {
      const raw = e.target.value.replace(/\D/g, '').slice(0, 6);
      e.target.value = raw.length <= 3 ? raw : raw.slice(0, 3) + '.' + raw.slice(3);
      this.els.codiceInput.classList.remove('is-error');
      this.els.codiceMsg.textContent = '';
      this.els.codiceMsg.className = 'tmh-codice-msg';
      this.hideConfermaCard();

      
      if (CODICE_REGEX.test(e.target.value)) {
        clearTimeout(this._autoValidateTimer);
        this._autoValidateTimer = setTimeout(() => this.onCodiceBlur(), 300);
      }
    }

    async onCodiceBlur() {
      const codice = this.els.codiceInput.value.trim();
      if (!codice) return;

      this.els.codiceMsg.textContent = this.msg.VERIFICA_IN_CORSO;
      this.els.codiceMsg.className = 'tmh-codice-msg is-loading';

      const result = validaCodice(codice);

      if (!result.valid) {
        this.els.codiceInput.classList.add('is-error');
        this.els.codiceMsg.textContent = this.msg[result.error] || this.msg.ERRORE_GENERICO;
        this.els.codiceMsg.className = 'tmh-codice-msg is-error';
        this.hideConfermaCard();
        return;
      }

      this.state.ambulanteCandidato = result.ambulante;
      this.els.codiceMsg.textContent = '';
      this.els.codiceMsg.className = 'tmh-codice-msg';
      this.els.codiceInput.classList.remove('is-error');
      this.showConfermaCard(result.ambulante);
    }

    showConfermaCard(amb) {
      this.els.cardNome.textContent = amb.nome;
      this.els.cardCodice.textContent = amb.codice;
      this.els.cardProvincia.textContent = amb.provincia;
      this.els.cardBadge.style.display = amb.isFacilitatore ? 'inline-block' : 'none';

      this.els.cardMercati.innerHTML = '';
      (amb.mercati || []).forEach((m) => {
        const li = document.createElement('li');
        const comune = m.comune || '';
        const freq = m.frequenza || '';
        li.innerHTML =
          `<strong>${m.title}</strong>` +
          (comune ? ` — ${comune}` : '') +
          (freq ? ` <span style="color:var(--tmh-testo-soft);">(${freq})</span>` : '');
        this.els.cardMercati.appendChild(li);
      });

      this.els.confermaCard.style.display = 'block';
    }

    hideConfermaCard() {
      this.els.confermaCard.style.display = 'none';
      this.state.ambulanteCandidato = null;
    }

    async onConferma() {
      const amb = this.state.ambulanteCandidato;
      if (!amb) return;

      const mercatiStr = (amb.mercati || [])
        .map((m) => {
          const comune = m.comune || '';
          const freq = m.frequenza || '';
          return m.title + (comune ? ' — ' + comune : '') + (freq ? ' (' + freq + ')' : '');
        })
        .join('|');

      await setCartAttributes({
        ambulante_codice: amb.codice,
        ambulante_nome: amb.nome,
        ambulante_provincia: amb.provincia,
        ambulante_is_facilitatore: String(amb.isFacilitatore),
        ambulante_mercati: mercatiStr,
        modalita_consegna: 'ritiro_mercato',
      });

      this.state.ambulanteConfermato = amb;
      this.state.ambulanteCandidato = null;

      this.hideConfermaCard();
      this.showMinicard(amb);
      this.updateCheckoutGate();
    }

    showMinicard(amb) {
      this.els.minicardNome.textContent = amb.nome;
      this.els.minicardCodice.textContent = amb.codice;
      this.els.minicard.style.display = 'flex';
      this.els.codiceForm.style.display = 'none';
    }

    hideMinicard() {
      this.els.minicard.style.display = 'none';
      this.els.codiceForm.style.display = 'block';
    }

    onCambia() {
      this.hideConfermaCard();
      this.els.codiceInput.value = '';
      this.els.codiceInput.focus();
    }

    onModifica() {
      this.hideMinicard();
      if (this.state.ambulanteConfermato) {
        this.els.codiceInput.value = this.state.ambulanteConfermato.codice;
        setTimeout(() => this.onCodiceBlur(), 50);
      }
    }

    async clearAmbulante() {
      await setCartAttributes({
        ambulante_codice: '',
        ambulante_nome: '',
        ambulante_provincia: '',
        ambulante_is_facilitatore: '',
        ambulante_mercati: '',
        modalita_consegna: 'spedizione_casa',
      });
      this.state.ambulanteConfermato = null;
      this.state.ambulanteCandidato = null;
      this.hideMinicard();
      this.hideConfermaCard();
      if (this.els.codiceInput) this.els.codiceInput.value = '';
      this.updateCheckoutGate();
    }

    async restoreFromCart() {
      try {
        const cart = await getCart();
        const attrs = cart.attributes || {};

        if (attrs.modalita_consegna === 'ritiro_mercato' && attrs.ambulante_codice) {
          
          this.state.ambulanteConfermato = {
            codice: attrs.ambulante_codice,
            nome: attrs.ambulante_nome,
            provincia: attrs.ambulante_provincia,
            isFacilitatore: attrs.ambulante_is_facilitatore === 'true',
          };
          const radioRitiro = this.root.querySelector('[data-tmh-modality-input][value="ritiro_mercato"]');
          if (radioRitiro) {
            radioRitiro.checked = true;
            this.onRadioChange('ritiro_mercato');
          }
          this.showMinicard(this.state.ambulanteConfermato);
        } else if (attrs.modalita_consegna === 'spedizione_casa') {
          const radioSpedizione = this.root.querySelector('[data-tmh-modality-input][value="spedizione_casa"]');
          if (radioSpedizione) {
            radioSpedizione.checked = true;
            this.onRadioChange('spedizione_casa');
          }
        }
      } catch (e) {
        log('Errore restoreFromCart', e);
      }
    }

    updateCheckoutGate() {
      setGateSource(
        this.root,
        () =>
          (this.state.modalita === 'ritiro_mercato' && !!this.state.ambulanteConfermato) ||
          this.state.modalita === 'spedizione_casa',
      );
      applyCheckoutGate();
      log('Modalita consegna', {
        modalita: this.state.modalita,
        hasAmbulante: !!this.state.ambulanteConfermato,
      });
    }
  }

  
  
  

  const FISC_CF_FORMA = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;
  const FISC_SDI_FORMA = /^[A-Z0-9]{7}$/;
  const FISC_PEC_FORMA = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;
  const FISC_CF_RESTO = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  const FISC_CF_DISPARI = {
    0: 1, 1: 0, 2: 5, 3: 7, 4: 9, 5: 13, 6: 15, 7: 17, 8: 19, 9: 21,
    A: 1, B: 0, C: 5, D: 7, E: 9, F: 13, G: 15, H: 17, I: 19, J: 21,
    K: 2, L: 4, M: 18, N: 20, O: 11, P: 3, Q: 6, R: 8, S: 12, T: 14,
    U: 16, V: 10, W: 22, X: 25, Y: 24, Z: 23,
  };

  const FISC_CF_PARI = {
    0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9,
    A: 0, B: 1, C: 2, D: 3, E: 4, F: 5, G: 6, H: 7, I: 8, J: 9,
    K: 10, L: 11, M: 12, N: 13, O: 14, P: 15, Q: 16, R: 17, S: 18, T: 19,
    U: 20, V: 21, W: 22, X: 23, Y: 24, Z: 25,
  };

  function pulisciCodiceFiscale(raw) {
    return String(raw || '').toUpperCase().replace(/\s+/g, '');
  }

  function pulisciPartitaIva(raw) {
    return String(raw || '').toUpperCase().replace(/[\s.\-]+/g, '').replace(/^IT/, '');
  }

  function validaPartitaIva(raw) {
    const v = pulisciPartitaIva(raw);
    if (!v) return { valid: false, error: 'PIVA_MANCA', value: '' };
    if (!/^\d{11}$/.test(v)) return { valid: false, error: 'PIVA_CIFRE', value: v };

    let somma = 0;
    for (let i = 0; i < 10; i += 1) {
      let n = v.charCodeAt(i) - 48;
      if (i % 2 === 1) {
        n *= 2;
        if (n > 9) n -= 9;
      }
      somma += n;
    }
    const controllo = (10 - (somma % 10)) % 10;
    if (controllo !== v.charCodeAt(10) - 48) return { valid: false, error: 'PIVA_CONTROLLO', value: v };

    return { valid: true, value: v };
  }

  function validaCodiceFiscale(raw) {
    const v = pulisciCodiceFiscale(raw);
    if (!v) return { valid: false, error: 'CF_MANCA', value: '' };

    if (/^\d{11}$/.test(v)) {
      const piva = validaPartitaIva(v);
      if (!piva.valid) return { valid: false, error: 'CF_NUM_CONTROLLO', value: v };
      return { valid: true, value: v };
    }

    if (!FISC_CF_FORMA.test(v)) return { valid: false, error: 'CF_FORMA', value: v };

    let somma = 0;
    for (let i = 0; i < 15; i += 1) {
      const c = v.charAt(i);
      somma += i % 2 === 0 ? FISC_CF_DISPARI[c] : FISC_CF_PARI[c];
    }
    if (FISC_CF_RESTO.charAt(somma % 26) !== v.charAt(15)) {
      return { valid: false, error: 'CF_CONTROLLO', value: v };
    }

    return { valid: true, value: v };
  }

  function validaSdi(raw) {
    const v = String(raw || '').toUpperCase().replace(/\s+/g, '');
    if (!v) return { valid: false, error: 'SDI_MANCA', value: '' };
    if (!FISC_SDI_FORMA.test(v)) return { valid: false, error: 'SDI_FORMA', value: v };
    return { valid: true, value: v };
  }

  function validaPec(raw) {
    const v = String(raw || '').trim().toLowerCase();
    if (!v) return { valid: false, error: 'PEC_MANCA', value: '' };
    if (!FISC_PEC_FORMA.test(v)) return { valid: false, error: 'PEC_FORMA', value: v };
    return { valid: true, value: v };
  }

  function validaRagioneSociale(raw) {
    const v = String(raw || '').trim().replace(/\s+/g, ' ');
    if (v.length < 2) return { valid: false, error: 'RS_MANCA', value: v };
    return { valid: true, value: v };
  }

  function validaFisc(dati) {
    const errori = {};
    const valori = { fisc_tipo: '', fisc_codice_fiscale: '', fisc_ragione_sociale: '', fisc_partita_iva: '', fisc_sdi: '', fisc_pec: '' };

    if (dati.tipo !== 'privato' && dati.tipo !== 'azienda') {
      return { valid: false, errori: { tipo: 'TIPO_MANCA' }, valori };
    }
    valori.fisc_tipo = dati.tipo;

    if (dati.tipo === 'privato') {
      const cf = validaCodiceFiscale(dati.codice_fiscale);
      if (!cf.valid) errori.codice_fiscale = cf.error;
      else valori.fisc_codice_fiscale = cf.value;
      return { valid: Object.keys(errori).length === 0, errori: errori, valori: valori };
    }

    const rs = validaRagioneSociale(dati.ragione_sociale);
    if (!rs.valid) errori.ragione_sociale = rs.error;
    else valori.fisc_ragione_sociale = rs.value;

    const piva = validaPartitaIva(dati.partita_iva);
    if (!piva.valid) errori.partita_iva = piva.error;
    else valori.fisc_partita_iva = piva.value;

    const sdiScritto = String(dati.sdi || '').trim() !== '';
    const pecScritta = String(dati.pec || '').trim() !== '';

    if (!sdiScritto && !pecScritta) {
      errori.sdi = 'SDI_PEC_MANCA';
      errori.pec = 'SDI_PEC_MANCA';
    } else {
      if (sdiScritto) {
        const sdi = validaSdi(dati.sdi);
        if (!sdi.valid) errori.sdi = sdi.error;
        else valori.fisc_sdi = sdi.value;
      }
      if (pecScritta) {
        const pec = validaPec(dati.pec);
        if (!pec.valid) errori.pec = pec.error;
        else valori.fisc_pec = pec.value;
      }
    }

    return { valid: Object.keys(errori).length === 0, errori: errori, valori: valori };
  }

  const FISC_ATTR_VUOTI = {
    fisc_tipo: '',
    fisc_codice_fiscale: '',
    fisc_ragione_sociale: '',
    fisc_partita_iva: '',
    fisc_sdi: '',
    fisc_pec: '',
  };

  function readFiscMessages(root) {
    const d = root.dataset;
    return {
      TIPO_MANCA: d.tmhFiscTipoManca,
      CF_MANCA: d.tmhFiscCfManca,
      CF_FORMA: d.tmhFiscCfForma,
      CF_CONTROLLO: d.tmhFiscCfControllo,
      CF_NUM_CONTROLLO: d.tmhFiscCfNumControllo,
      RS_MANCA: d.tmhFiscRsManca,
      PIVA_MANCA: d.tmhFiscPivaManca,
      PIVA_CIFRE: d.tmhFiscPivaCifre,
      PIVA_CONTROLLO: d.tmhFiscPivaControllo,
      SDI_MANCA: d.tmhFiscSdiPecManca,
      SDI_PEC_MANCA: d.tmhFiscSdiPecManca,
      SDI_FORMA: d.tmhFiscSdiForma,
      PEC_MANCA: d.tmhFiscSdiPecManca,
      PEC_FORMA: d.tmhFiscPecForma,
    };
  }

  class TMHCartFisc {
    constructor(root) {
      this.root = root;
      this.msg = readFiscMessages(root);

      this.els = {
        radios: root.querySelectorAll('[data-tmh-fisc-input]'),
        radioLabels: root.querySelectorAll('[data-tmh-fisc-radio]'),
        expands: root.querySelectorAll('[data-tmh-fisc-expand]'),
        campi: {},
        msg: {},
      };
      root.querySelectorAll('[data-tmh-fisc-field]').forEach((el) => {
        this.els.campi[el.dataset.tmhFiscField] = el;
      });
      root.querySelectorAll('[data-tmh-fisc-msg]').forEach((el) => {
        this.els.msg[el.dataset.tmhFiscMsg] = el;
      });

      this.state = { tipo: null, esito: null, tocco: {} };
      this._ultimoInvio = null;
      this._pronto = false;

      this.bind();
      this.restoreFromCart();
    }

    bind() {
      this.els.radios.forEach((r) => r.addEventListener('change', () => this.onTipoChange(r.value)));

      Object.keys(this.els.campi).forEach((k) => {
        const el = this.els.campi[k];
        el.addEventListener('input', () => this.aggiorna());
        el.addEventListener('blur', () => {
          this.state.tocco[k] = true;
          this.normalizzaCampo(k);
          this.aggiorna();
        });
      });
    }

    setTipo(valore) {
      this.state.tipo = valore;
      this.els.radioLabels.forEach((l) => {
        l.classList.toggle('is-selected', l.dataset.tmhFiscRadio === valore);
      });
      this.els.expands.forEach((e) => {
        e.classList.toggle('is-open', e.dataset.tmhFiscExpand === valore);
      });
    }

    onTipoChange(valore) {
      this.setTipo(valore);

      const daSvuotare =
        valore === 'privato' ? ['ragione_sociale', 'partita_iva', 'sdi', 'pec'] : ['codice_fiscale'];
      daSvuotare.forEach((k) => {
        if (this.els.campi[k]) this.els.campi[k].value = '';
        this.state.tocco[k] = false;
      });

      this.state.tocco.tipo = true;
      this.aggiorna();
    }

    normalizzaCampo(k) {
      const el = this.els.campi[k];
      if (!el || !el.value) return;
      let v = el.value;
      if (k === 'codice_fiscale') v = pulisciCodiceFiscale(v);
      else if (k === 'partita_iva') v = pulisciPartitaIva(v);
      else if (k === 'sdi') v = String(v).toUpperCase().replace(/\s+/g, '');
      else if (k === 'pec') v = String(v).trim();
      else v = String(v).trim().replace(/\s+/g, ' ');
      if (v !== el.value) el.value = v;
    }

    leggi() {
      const c = this.els.campi;
      return {
        tipo: this.state.tipo,
        codice_fiscale: c.codice_fiscale ? c.codice_fiscale.value : '',
        ragione_sociale: c.ragione_sociale ? c.ragione_sociale.value : '',
        partita_iva: c.partita_iva ? c.partita_iva.value : '',
        sdi: c.sdi ? c.sdi.value : '',
        pec: c.pec ? c.pec.value : '',
      };
    }

    aggiorna() {
      this.state.esito = validaFisc(this.leggi());
      this.mostraMessaggi();
      this.updateCheckoutGate();
      this.programmaSalvataggio();
    }

    mostraMessaggi() {
      const errori = (this.state.esito && this.state.esito.errori) || {};
      Object.keys(this.els.msg).forEach((k) => {
        const box = this.els.msg[k];
        const campo = this.els.campi[k];
        const codice = errori[k];
        const visibile = !!codice && this.state.tocco[k] === true;
        box.textContent = visibile ? this.msg[codice] || '' : '';
        box.className = visibile ? 'tmh-fisc-msg is-error' : 'tmh-fisc-msg';
        if (campo) campo.classList.toggle('is-error', visibile);
      });
    }

    updateCheckoutGate() {
      setGateSource(this.root, () => !!(this.state.esito && this.state.esito.valid));
      applyCheckoutGate();
    }

    programmaSalvataggio() {
      if (!this._pronto) return;
      clearTimeout(this._salvaTimer);
      this._salvaTimer = setTimeout(() => this.salva(), 400);
    }

    async salva() {
      const esito = this.state.esito;
      const attrs =
        esito && esito.valid
          ? esito.valori
          : Object.assign({}, FISC_ATTR_VUOTI, { fisc_tipo: this.state.tipo || '' });

      const firma = JSON.stringify(attrs);
      if (firma === this._ultimoInvio) return;
      this._ultimoInvio = firma;

      try {
        await setCartAttributes(attrs);
      } catch (e) {
        this._ultimoInvio = null;
        log('Errore salvataggio dati fiscali', e);
      }
    }

    async restoreFromCart() {
      try {
        const cart = await getCart();
        const a = cart.attributes || {};

        this._ultimoInvio = JSON.stringify({
          fisc_tipo: a.fisc_tipo || '',
          fisc_codice_fiscale: a.fisc_codice_fiscale || '',
          fisc_ragione_sociale: a.fisc_ragione_sociale || '',
          fisc_partita_iva: a.fisc_partita_iva || '',
          fisc_sdi: a.fisc_sdi || '',
          fisc_pec: a.fisc_pec || '',
        });

        if (a.fisc_tipo === 'privato' || a.fisc_tipo === 'azienda') {
          const radio = this.root.querySelector('[data-tmh-fisc-input][value="' + a.fisc_tipo + '"]');
          if (radio) radio.checked = true;
          this.setTipo(a.fisc_tipo);

          const c = this.els.campi;
          if (c.codice_fiscale) c.codice_fiscale.value = a.fisc_codice_fiscale || '';
          if (c.ragione_sociale) c.ragione_sociale.value = a.fisc_ragione_sociale || '';
          if (c.partita_iva) c.partita_iva.value = a.fisc_partita_iva || '';
          if (c.sdi) c.sdi.value = a.fisc_sdi || '';
          if (c.pec) c.pec.value = a.fisc_pec || '';
        }
      } catch (e) {
        log('Errore restore dati fiscali', e);
      } finally {
        this._pronto = true;
        this.aggiorna();
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-tmh-cart-modality]').forEach((el) => {
      new TMHCartModality(el);
    });
    document.querySelectorAll('[data-tmh-cart-fisc]').forEach((el) => {
      new TMHCartFisc(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  
  document.addEventListener('cart:refresh', init);
  document.addEventListener('cart:updated', init);
})();
